import { type FC } from 'react'

import { algoliaProxyRecordAccessorGetDeeplink } from '../../../algolia'
import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK } from '../../../experiments/eventTracking'
import { useTrackOptimizelyExperimentEvent } from '../../../experiments/hooks/useTrackOptimizelyExperimentEvent'
import { experimentAccessorIsHomeOneSerpEnabled } from '../../../experiments/model/experimentAccessor'
import { ProductPicture } from '../../../product'

import { useProductSearchResultItemContext } from './ProductSearchResultItemContext/productSearchResultItemContext'

const MAX_IMAGE_SIZE = 100

export const ProductSearchResultItemImage: FC = () => {
  const { algoliaRecord, query = '' } = useProductSearchResultItemContext()

  const { experiments } = useExperimentsContext()

  const trackProductClickEvent = useTrackOptimizelyExperimentEvent(
    EXPERIMENTS_TRACK_EVENT_SEARCH_PAGE_PRODUCT_DETAIL_CLICK,
  )

  const isHomeOneSerpEnable =
    experimentAccessorIsHomeOneSerpEnabled(experiments)

  const {
    __position: position,
    __queryID: queryID = '',
    image,
    productName,
  } = algoliaRecord

  return (
    // Switching to `NextLink` investigation under https://jira.shop-apotheke.com/browse/WSAWA-7078
    <a
      className="z-10 shrink-0"
      data-qa-id="serp-result-item-image"
      href={algoliaProxyRecordAccessorGetDeeplink({
        params: {
          eventName: 'click on product image',
          position,
          query,
          queryID,
        },
        record: algoliaRecord,
      })}
      onClick={(): void => {
        if (isHomeOneSerpEnable) {
          trackProductClickEvent()
        }
      }}
    >
      <ProductPicture
        className="size-[70px] tablet:size-[100px]"
        imageProps={{
          alt: productName,
          'data-analytics': 'item-image',
          height: MAX_IMAGE_SIZE,
          src: image,
          width: MAX_IMAGE_SIZE,
        }}
      />
    </a>
  )
}
